import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 5a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2l0 -10","key":"svg-0"}],["path",{"d":"M12 12a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-1"}],["path",{"d":"M16 8a2 2 0 1 0 -4 0v4","key":"svg-2"}],["path",{"d":"M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2","key":"svg-3"}]]

const IconBoxMultiple6 = createReactComponent('outline', 'box-multiple-6', 'BoxMultiple6', __iconNode);

export default IconBoxMultiple6;